<template>
  <div>
    <qb-table>
      <template v-slot:thead>
        <qb-tr style="width: 100%">
          <qb-th class="f-14" style="width: 20%">
            {{ $t('client') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 20%">
            {{ $tc('complementary') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 20%">
            {{ $t('folio') | capitalize }}
          </qb-th>
          <qb-th class="f-14" style="width: 20%">
            {{ $t('date') | capitalize }} 
          </qb-th>
          <qb-th class="f-14" style="width: 20%">
            {{ $t('amount') | capitalize }}
          </qb-th>
        </qb-tr>
      </template>
      <template v-slot:tbody>
        <qb-tr v-for="(el, idx) in data" :key="idx">
          <qb-td>{{ el.client_name | capitalize }}</qb-td>
          <qb-td>{{ el.complementary | capitalize }}</qb-td>
          <qb-td>{{ el.folio | capitalize}} </qb-td>
          <qb-td>{{ formatDate(el.date) }} </qb-td>
          <qb-td>${{ formatNumber(el.amount,2) }} </qb-td>
        </qb-tr>
        <qb-tr>
          <qb-td colspan="100%">
            <div
              v-if="data.length"
              v-observe-visibility="infiniteHandler"
            ></div>
          </qb-td>
        </qb-tr>
      </template>
    </qb-table>
  </div>
</template>

<script>
import QbTable from '@/views/qb-components/table/QbTable.vue'
import QbTr from '@/views/qb-components/table/QbTr.vue'
import QbTh from '@/views/qb-components/table/QbTh.vue'
import QbTd from '@/views/qb-components/table/QbTd.vue'
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
export default {
  name: 'ehs-table',
  components: {
    ActionIcon,
    QbTable,
    QbTr,
    QbTh,
    QbTd,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    showDetails(item) {
      this.$emit('showDetails', item.id)
    },
    infiniteHandler(isVisible) {
      if (!isVisible) {
        return
      }
      this.$emit('loadMore')
    }
  },
}
</script>

<style>
.chip-status {
  max-width: 9rem;
  min-width: 2rem;
  color: white;
  text-align: center;
  border-radius: 0.3em;
}
</style>
